import React, { useEffect, useMemo, useState } from 'react';

import Dropdown from "@cayuse/shared-react.components.dropdown";
import { crunchClasses } from "@cayuse/shared-react.utils.helpers";

import { EditableTableCell } from "components/BudgetBuilder/shared/EditableTableCell";
import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { MEMBER_TYPES, REQUIREMENT_DROPDOWN_ITEMS, TYPE_DROPDOWN_OPTIONS } from "globals/constants";
import { getMemberSubtotal } from "utils/budgetBuilder";
import { findUnitById } from "utils/picklists";

import styles from "./styles.css";

const createDefaultDataSet = category => ({
	baseSalary: category.baseSalary,
	apptMonths: category.apptMonths,
	effort: category.effort,
	personMonths: category.personMonths,
	fringeRate: category.fringeRate,
	reqSalary: category.reqSalary,
	unit: category.association || category?.associations?.[0]?.association,
	requirement: null,
	type: null,
});


const InternalCostShareResearchTeamRow = ({
	category,
	isEditing,
	handleMemberUpdate
}) => {
	const { requirement, unit, type } = useMemo(
		() => category?.costShare || createDefaultDataSet(category),
		[ category ],
	);

	const { currencyFormatter } = useTenantFormatter();
	const [ unitObject, setUnitObject ] = useState(null);

	useEffect(() => {
		const loadResearchTeamUnit = async () => {
			const unitObject = await findUnitById(unit);
			setUnitObject(unitObject);
		};

		loadResearchTeamUnit(unit);
	}, []);

	const classNames = crunchClasses({
		[styles.row]: true,
	});

	const subtotalAmountString = useMemo(
		() => getMemberSubtotal(category, true),
		[ category ]
	);

	const handleUpdate = update => {
		handleMemberUpdate(category.id, {
			...category,
			costShare: {
				...category?.costShare || createDefaultDataSet(category),
				...update,
			},
		});
	};

	const memberName = useMemo(
		() => category.type === MEMBER_TYPES.MEMBER_UNNAMED ? "Unnamed Member" : category?.name,
		[ category ]
	);

	return (
		<Table.Row key={category?.hash} className={classNames}>
			<Table.Cell className={styles.cellAlignLeft}>
				{`Research Team - ${memberName}`}
			</Table.Cell>
			<EditableTableCell
				editable={isEditing}
				inputStyles={styles.periodDropdown}
				cellStyles={`${styles.cellAlignLeft} ${styles.cellWithDropdown}`}
				onChange={(e, { value }) => handleUpdate({ requirement: value })}
				value={requirement}
				renderInput={props => (
					<Dropdown
						{...props}
						selection
						options={REQUIREMENT_DROPDOWN_ITEMS}
					/>
				)}
			/>
			<Table.Cell className={styles.cellAlignLeft}>
				{unitObject?.name}
			</Table.Cell>
			<EditableTableCell
				editable={isEditing}
				inputStyles={styles.periodDropdown}
				cellStyles={styles.cellAlignLeft}
				onChange={(e, { value }) => handleUpdate({ type: value })}
				value={type}
				renderInput={props => (
					<Dropdown
						{...props}
						selection
						options={TYPE_DROPDOWN_OPTIONS}
					/>
				)}
			/>
			<Table.Cell />
			<Table.Cell />
			<Table.Cell className={styles.valueCellPadding} />
			<Table.Cell className={styles.valueCellPadding} />
			<Table.Cell className={styles.cellAlignRight}>
				{currencyFormatter(subtotalAmountString)}
			</Table.Cell>
			<Table.Cell className={styles.cellAlignCenter} />
		</Table.Row>
	);
};

export default InternalCostShareResearchTeamRow;
